import { Check, DeleteOutlineOutlined, EditNote } from "@mui/icons-material";
import { CSSObjectWithLabel, StylesConfig } from "react-select";
import styled from "styled-components";

import { WrapperButton } from "@ryde/controls";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  deepPurpleMui,
  greyMui,
  orangeMui,
  redMui,
  rydeColors,
  ScreenDepth,
  tealMui,
} from "@ryde/theme";

export const ReportSelectUpdateIconStyled = styled(
  EditNote,
).attrs<IStyledAttributes>({
  "data-e2e": "view-dropdown-update-icon",
})`
  width: 17px;
  height: 17px;
  cursor: pointer;
  &:hover {
    color: ${tealMui.A700};
  }
`;

export const ReportSelectCheckIconStyled = styled(
  Check,
).attrs<IStyledAttributes>({
  "data-e2e": "report-select-check-icon",
})`
  width: 17px;
  height: 17px;
  cursor: pointer;
  &:hover {
    color: ${tealMui.A700};
  }
`;

export const ReportSelectDeleteIconStyled = styled(
  DeleteOutlineOutlined,
).attrs<IStyledAttributes>({
  "data-e2e": "report-select-delete-icon",
})`
  width: 17px;
  height: 17px;

  cursor: pointer;
  &:hover {
    color: ${redMui._500};
  }
`;

export const ReportSelectLabelContainer = styled.span.attrs<IStyledAttributes>({
  "data-e2e": "report-select-label-container",
})`
  display: block;
  max-width: calc(100% - 40px);
`;
export const ReportSelectDropdownIconsContainer = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "report-select-icons-container",
  },
)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
`;

export const ReportSelectViewOptionContainer = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "report-select-option-container",
  },
)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 16px;
`;

export const ReportSelectHoverWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "report-select-hover-wrapper",
})`
  width: 100%;
  &.active_view > div {
    color: ${redMui._800};
    font-weight: 700;
    background-color: ${orangeMui._100};
  }
  &.active_view:hover > div {
    color: ${redMui._900};
    font-weight: 700;
    background-color: ${orangeMui._300};
  }
  .apply_view_icon_wrapper,
  .update_view_icon_wrapper,
  .delete_view_icon_wrapper {
    display: none;
  }

  &:hover {
    .apply_view_icon_wrapper,
    .update_view_icon_wrapper,
    .delete_view_icon_wrapper {
      display: inline-block;
    }
  }

  .apply_view_icon_wrapper--is_default_view.apply_view_icon_wrapper {
    display: inline-block;
  }
  .apply_view_icon_wrapper--is_selected.apply_view_icon_wrapper {
    display: inline-block;
  }
  .apply_view_icon_wrapper--is_default_view .apply_view_icon {
    color: ${tealMui.A700};
  }
  .apply_view_icon_wrapper--is_selected .apply_view_icon {
    color: ${blueGreyMui._300};
  }
`;

export const reportSelectStyles: StylesConfig<unknown, false> = {
  control: provided =>
    ({
      ...provided,
      position: "absolute",
      width: 401,
      top: 8,
      insetInlineStart: 0,
      height: 40,
      zIndex: ScreenDepth.HEADER_FORM_CONTROLS,
      borderColor: greyMui._200,
      boxShadow: "none",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      paddingInlineStart: 10,
      ":hover": {
        borderColor: greyMui._200,
      },
    }) as CSSObjectWithLabel,
  menu: provided =>
    ({
      ...provided,
      borderRadius: 4,
      position: "absolute",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      zIndex: ScreenDepth.HEADER_FORM_CONTROLS,
      margin: 0,
      top: 49,
      insetInlineStart: 0,
      width: 400,
    }) as CSSObjectWithLabel,
  menuList: provided =>
    ({
      ...provided,
      padding: 0,
      marginTop: "-1px",
    }) as CSSObjectWithLabel,
  option: provided =>
    ({
      ...provided,
      backgroundColor: rydeColors.white,
      color: rydeColors.black,
      ":hover": {
        backgroundColor: greyMui._200,
      },
      " .active_view": {
        backgroundColor: orangeMui._200,
      },
    }) as CSSObjectWithLabel,
  input: provided =>
    ({
      ...provided,
      ":hover": {
        border: "none",
      },
    }) as CSSObjectWithLabel,
};

export const ReportSelectWrapperStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "report-select-wrapper",
})`
  /* margin-top: 8px; */
  margin-inline-end: 10px;
  > span {
    padding: 7px;
    background-color: white;
    border-radius: 6px;
  }
  .dropdown_blanket {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    position: fixed;
    z-index: ${ScreenDepth.MAIN_CONTAINER};
  }
`;

export const ReportSelectButtonStyled = styled(
  WrapperButton,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "report-select-button",
})`
  color: ${deepPurpleMui.A700};
  display: flex;
  align-items: center;
  gap: 1px;
  label {
    margin-inline-start: 6px;
    cursor: pointer;
    font-size: 14px;
  }
  svg.ReportSelectButtonSVG {
    width: auto;
    height: 20px;
    display: block;
  }
`;
